<!--
存在form的情况下，form-item有margin-bottom，所以 custom-class = form-dialog
需要指定宽度的情况下，需要指定custom-class，否则默认 my-dialog有最大宽度
-->
<template>
  <el-dialog
    :modal="modal"
    :close-on-click-modal="false"
    :show-close="false"
    :custom-class="($attrs['custom-class']||'my-dialog') + (isHeaderBorder ? ' headerBorder' : '')"
    v-bind.sync="$attrs"
    v-on="$listeners"
  >
    <div slot="title" class="title-box">
      <div v-if="$attrs.title">{{ $attrs.title }}</div>
      <slot name="title" />
      <i class="el-icon-close" @click="close" />
      <!-- <el-button style="width: 72px;z-index: 9999;" size="medium" @click="close">关闭</el-button> -->
    </div>
    <div class="section" :class="{'padding-section': !$slots.footer}">
      <slot />
      <div v-if="$slots.section" class="section-content">
        <slot name="section" />
      </div>
      <!--      <div v-if="$slots.footer" class="footer-box">-->
      <!--        <slot name="footer" />-->
      <!--      </div>-->
    </div>
    <div v-if="$slots.footer" slot="footer" class="footer-box">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'MyDialog',
  inheritAttrs: false,
  props: {
    isHeaderBorder: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  watch: {

  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>

/deep/ .el-dialog {
  border-radius: 9px!important;
  max-height: 95vh !important;
  overflow: auto;
}

/deep/ .my-dialog {
  max-width: 563px;
  width: auto;
}
// 存在form的弹窗
/deep/ .form-dialog {
  .el-dialog__body {
    padding-bottom: 0 !important;
  }

  .padding-section {
    padding-bottom: 30px;
  }
}

/deep/ .el-dialog__header {
  height: 72px;
  padding: 0 20px 0 20px!important;
  font-size: 16px;
  color: #333
}
/deep/ .headerBorder {
  .el-dialog__header {
    border-bottom: 1px solid #F5F6F5;
  }
}
/deep/ .el-dialog__body {
  box-sizing: border-box;
  padding: 30px;
  max-height: calc(95vh - 160px - 40px) !important;
}
.footer-box {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 10px;
  /deep/ .el-button {
    width: 144px !important;
    margin: 0 24px 0 0;
  }
  /deep/ .el-button:last-child {
    margin-right: 0;
  }
  /deep/ .el-button--normal {
    background: #E8E8E8 !important;
    color: #333 !important;

    &:hover {
      background: #F0F0F0 !important;
      color: #333 !important;
      border-color: #F0F0F0 !important;
    }

  }

}

.section-content {
  width: 100%;
}

/deep/ .section-content > * {
  width: 100% !important;
}

.section {
  line-height: 24px;
  font-size: 16px;
  width: 100%;
}
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  i {
    cursor: pointer;
  }
}
</style>
